<template>
  <AcademicCardsChapter
    page-title="学术评价"
    section-label="学科建设"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :sections="sections"
  />
</template>

<script>
import AcademicCardsChapter from '@/components/AcademicCardsChapter.vue';

export default {
  name: 'Lanhuxueshupingjia',
  components: {
    AcademicCardsChapter
  },
  data() {
    return {
      sectionRoute: '/lanhu_xuekeyukeyan',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      sections: [
        {
          title: '优秀论文遴选机制',
          summary: '新闻与传播研究所作为国家级研究机构，力求在完善新闻传播学科研究成果的评价机制、提高学术质量方面有所担当和推动。从 2013 年起，每年从国内公开发表的众多论文中遴选若干高水准佳作，以反映该年度新闻传播学研究的新进展，为学界提供可资借鉴的学术样本。',
          columns: 2,
          cards: [
            {
              title: '2013 年首届优秀论文遴选资料',
              src: require('./assets/html/evaluation-2013-materials.jpg'),
              description: '2013 年，首届（2012 年度）全国新闻传播学优秀论文遴选资料整理完成。'
            },
            {
              title: '2014 年第十二届中国传播学大会颁奖',
              src: require('./assets/html/evaluation-2014-award.jpg'),
              description: '2014 年 10 月，在第十二届中国传播学大会上举行优秀论文遴选活动颁奖。'
            }
          ]
        },
        {
          title: '定评会与大会颁奖',
          summary: '学术评价工作逐步形成定评会、年度遴选与大会表彰相衔接的工作链条。',
          columns: 2,
          cards: [
            {
              title: '2018 年第六届定评会',
              src: require('./assets/html/evaluation-2018-review.jpg'),
              description: '2018 年 10 月，第六届（2017 年度）全国新闻传播学优秀论文遴选活动定评会举行。'
            },
            {
              title: '2016 年第十三届中国传播学大会颁奖',
              src: require('./assets/html/evaluation-2016-award.jpg'),
              description: '2016 年 10 月，在第十三届中国传播学大会上颁发第四届（2015 年度）全国新闻传播学优秀论文遴选活动奖项。'
            },
            {
              title: '2018 年第十四届中国传播学大会颁奖',
              src: require('./assets/html/evaluation-2018-award.jpg'),
              description: '2018 年 10 月，在第十四届中国传播学大会上举行优秀论文遴选活动颁奖。'
            }
          ]
        }
      ]
    };
  }
};
</script>
